var _circle, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKpop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "#F3E8FF",
    stroke: "#A855F7",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(35 32 32)",
    stroke: "#6B21A8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 11,
    width: 16,
    height: 27,
    rx: 8,
    fill: "#C084FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 22h16M24 28h16M28 38v13a4 4 0 0 0 8 0V38",
    fill: "#F3E8FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47 10 1.5 4.5L53 16l-4.5 1.5L47 22l-1.5-4.5L41 16l4.5-1.5z",
    fill: "#A855F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpop);
export default __webpack_public_path__ + "static/media/kpop.904f9ccb996e0b8aba86a76f2b4ddd14.svg";
export { ForwardRef as ReactComponent };